import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createReferenceToNode, useAppContext, } from '@datapad/data-model';
import { Edit } from '@mui/icons-material';
import { Autocomplete, Box, TextField as MuiTextField, Typography } from '@mui/material';
import React from 'react';
export function CampaignPicker(props) {
    const { campaign, onChange, canEdit = false } = props;
    const appContext = useAppContext();
    const [isEditing, setIsEditing] = React.useState(false);
    const campaigns = React.useMemo(() => appContext.getAllCampaigns(), [appContext]);
    const currentCampaign = React.useMemo(() => {
        return appContext.getCampaign(campaign);
    }, [appContext, campaign]);
    const handleStartEdit = React.useCallback(() => {
        if (canEdit) {
            setIsEditing(true);
        }
    }, [canEdit]);
    const handleChange = React.useCallback((newCampaign) => {
        if (newCampaign) {
            const ref = createReferenceToNode(newCampaign);
            onChange(ref);
        }
        setIsEditing(false);
    }, [onChange]);
    if (isEditing) {
        return (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: _jsx(Autocomplete, { size: "small", options: campaigns, getOptionLabel: (c) => c.name, value: currentCampaign, onChange: (_, newValue) => handleChange(newValue), onBlur: () => setIsEditing(false), renderInput: (params) => (_jsx(MuiTextField, { ...params, label: "Campaign", autoFocus: true })), sx: { minWidth: 200, flexGrow: 1 }, disableClearable: true, autoHighlight: true, openOnFocus: true }) }));
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: canEdit ? 'pointer' : 'default',
            '&:hover': canEdit
                ? {
                    backgroundColor: 'action.hover',
                    borderRadius: 1,
                }
                : {},
            padding: 0.5,
            marginLeft: -0.5,
            borderRadius: 1,
        }, onClick: handleStartEdit, children: [_jsxs(Typography, { variant: "body2", children: [_jsx("strong", { children: "Campaign:" }), " ", currentCampaign.name] }), canEdit && (_jsx(Edit, { fontSize: "small", sx: {
                    color: 'action.active',
                    opacity: 0.5,
                    '&:hover': { opacity: 1 },
                } }))] }));
}
//# sourceMappingURL=CampaignPicker.js.map